import { render, staticRenderFns } from "./ViewOnGithub.vue?vue&type=template&id=0a3727bf&scoped=true&"
import script from "./ViewOnGithub.vue?vue&type=script&lang=js&"
export * from "./ViewOnGithub.vue?vue&type=script&lang=js&"
import style0 from "./ViewOnGithub.vue?vue&type=style&index=0&id=0a3727bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3727bf",
  null
  
)

export default component.exports